/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
import * as l from "react";
import { clientColumn as C, resolveCells as f, isClientReference as u } from "../utils/index.mjs";
import { classNames as p } from "@progress/kendo-react-common";
import { FooterCellContainer as m } from "./client/FooterCellContainer.mjs";
const v = (t) => {
  const { column: e, index: n, cells: a } = t, o = {
    colSpan: e.colSpan !== 1 ? e.colSpan : void 0,
    className: p("k-table-td", e.locked && e.left !== void 0 ? "k-grid-footer-sticky" : ""),
    role: "gridcell",
    "aria-colindex": e.ariaColumnIndex
  }, c = {
    field: e.field,
    ariaColumnIndex: e.ariaColumnIndex,
    ...o
  }, i = C(e), r = f(a, e.cells);
  if (r && r.footerCell) {
    const s = r.footerCell, d = u(s);
    return /* @__PURE__ */ l.createElement(
      m,
      {
        key: n,
        id: t.id,
        tdProps: o,
        isCustom: !0,
        isClient: d,
        column: i
      },
      /* @__PURE__ */ l.createElement(s, { ...c, tdProps: o, index: n })
    );
  }
  return /* @__PURE__ */ l.createElement(m, { key: n, id: t.id, column: i }, e.footerCell && /* @__PURE__ */ l.createElement(e.footerCell, { ...c }) || /* @__PURE__ */ l.createElement("td", { ...o }));
};
export {
  v as FooterCell
};
